/* global toastr:false, moment:false */
(function() {
    'use strict';
    const production = true;
    angular
        .module('app.core')
        .constant('moment', moment)
        .constant('toastr', toastr)
        .constant('signaturePad', signaturePad)
        .constant('heligreenVersion', 30)
        .constant('apiSettings', {  
            apiBaseUrl: production ? 'https://www.racers506.com/HeliGreen_WebAPI/' : 'http://localhost/ITGHeliGreen_RestAPI/'  
        });
})();
